import qs from "qs";
import fromEntries from "./fromEntries";

const trimParams = (paramsObject) => {
  const paramsEntries = Object.entries(paramsObject);
  const trimmedParams = paramsEntries.filter(([, value]) => !!value);
  return fromEntries(trimmedParams);
};

export function setQueryString(history, ...params) {
  const { location } = history;
  const paramsObject = fromEntries(params);

  const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const newParams = trimParams({ ...qsParams, ...paramsObject });

  const qsValue = qs.stringify(newParams);
  history.replace(`${location.pathname}?${qsValue}`, location.state);
}

export function setQueryStringAndRetainHash(history, ...params) {
  const { location } = history;
  const paramsObject = fromEntries(params);

  const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const qsValue = qs.stringify(
    {
      ...qsParams,
      ...paramsObject,
    },
    { addQueryPrefix: true }
  );
  history.replace(
    `${location.pathname}${qsValue}${location.hash}`,
    location.state
  );
}

export function getQueryParam(history, paramKey) {
  const qsParams = qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  });
  const paramValue = qsParams[paramKey];
  return paramValue;
}
